function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 0.907,
  x2: 0.163,
  y1: 0.227,
  y2: 0.853,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b6509e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2ebac6"
})));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "url(#a)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.251 16.78l-4.059-9.809a1.091 1.091 0 00-1.017-.755h-.359a1.091 1.091 0 00-1.017.755l-1.766 4.274H7.697a.731.731 0 00-.728.725v.01a.731.731 0 00.728.725h.718L6.73 16.78a.86.86 0 00-.05.278.767.767 0 00.2.547.7.7 0 00.539.209.729.729 0 00.419-.139.885.885 0 00.289-.368l1.853-4.601h1.287a.731.731 0 00.728-.725v-.02a.731.731 0 00-.728-.725h-.687l1.415-3.529 3.859 9.6a.885.885 0 00.289.368.729.729 0 00.419.139.7.7 0 00.539-.209.767.767 0 00.2-.547.657.657 0 00-.05-.278z"
});

var SvgAave = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAave, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/aave.8cfef2c7.svg";
export { ForwardRef as ReactComponent };